<template>
  <v-dialog v-model="showDialog" width="500">
    <v-card v-if="item">
      <v-card-title>
        <div class="title">
          {{ $lang("ADD") + "/" + $lang("REMOVE") + " " + $lang("BUYERS") }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              :label="$lang('Username')"
              v-model="item.username"
              clearable
              :error-messages="errors && errors.username ? errors.username : []"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text style="max-height: 400px; overflow: scroll">
        <v-chip
          @click.stop="attachExisting(itm)"
          small
          :style="'background:' + getRandomColorLuminance() + '; color: white'"
          class="ma-1"
          v-for="itm in filteredItems"
          :key="itm.id"
        >
          {{ itm.username }}
        </v-chip>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { getRandomColorLuminance } from "@/helpers/utils";

export default {
  name: "new-buyer-dialog",
  props: ["show", "buyers", "ident"],
  emits: ["closed", "created"],
  components: {},
  data() {
    return {
      item: {
        id: null,
        title: "",
      },
      filteredItems: [],
      showDialog: null,
    };
  },
  computed: {
    ...mapGetters({
      auth: "auth/auth",
    }),
    errors: {
      get() {
        return this.$store.getters.getFormErrors;
      },
      set(_) {},
    },
  },
  watch: {
    "item.username"(val) {
      this.filterItems();
    },
    buyers(buyers) {
      this.filterItems();
      this.item = {};
    },
    show(val) {
      this.showDialog = val;
      this.item = {};
    },
    showDialog(val) {
      let closed = !val ? true : false;
      this.$emit("closed", closed);
    },
  },
  methods: {
    getRandomColorLuminance() {
      return getRandomColorLuminance(-0.6);
    },
    attachExisting(buyer) {
      this.$emit("created", buyer);
      this.item = {};
    },
    filterItems() {
      let val =
        this.item && this.item.username ? this.item.username.toLowerCase() : "";
      this.filteredItems = this.buyers.filter((el) => {
        return el.username.toLowerCase().includes(val);
      });
    },
  },
  created() {
    this.showDialog = this.show;
  },
};
</script>
